<template>
    <div>
        <h1>{{$t('global.menu.contactForm')}}</h1>
        <form @submit.prevent="handleSubmit">
            <div class="form-row">
                <div class="col-md-4 form-group">
                    <label for="subject" class="control-label">{{ $t('contactForm.subject') }}</label>
                    <b-form-select required id="subject" v-model="contact.subject">
                        <option value="Account removal">{{ $t('contactForm.subjects.accountRemoval') }}</option>
                        <option value="Functional question">{{ $t('contactForm.subjects.functionalQuestion') }}</option>
                        <option value="Technical feedback">{{ $t('contactForm.subjects.technicalFeedback') }}</option>
                        <option value="Suggestion">{{ $t('contactForm.subjects.suggestion') }}</option>
                        <option value="Other">{{ $t('contactForm.subjects.other') }}</option>
                    </b-form-select>
                </div>
            </div>
            <div class="form-row" v-if="!logged">
                <div class="col-md-4 form-group">
                    <label for="from" class="control-label">{{ $t('contactForm.from') }}</label>
                    <b-form-input v-model="contact.from" type="email" id="from"/>
                </div>
            </div>
            <div class="form-row">
                <div class="col-12 form-group">
                    <label for="message" class="control-label">{{ $t('contactForm.message') }}</label>
                    <b-form-textarea id="message"
                                     v-model="contact.message"
                                     :rows="10" required>
                    </b-form-textarea>
                </div>
            </div>
            <vue-recaptcha v-if="!logged" ref="captcha" :sitekey="RECAPTCHA_SITE_KEY" size="normal" @verify="handleCaptchaVerify"
                           @expired="handleCaptchaExpired">
            </vue-recaptcha>
            <button type="submit" class="btn btn-primary" :disabled="loading || (contact.token === null && !logged)">{{
                $t('global.form.submit') }}
            </button>
        </form>
    </div>
</template>

<script>
import {mapGetters} from 'vuex';
import VueRecaptcha from 'vue-recaptcha';
import {RECAPTCHA_SITE_KEY} from '../../config/_recaptcha';

function getDefaultContact() {
    return {
        from: null,
        subject: null,
        message: null,
    }
}

export default {
    components: {VueRecaptcha},
    data: () => {
        return {
            RECAPTCHA_SITE_KEY: RECAPTCHA_SITE_KEY,
            contact: {
                ...getDefaultContact(),
                token: null
            }
        }
    },
    computed: mapGetters({
        logged: 'user/auth/logged',
        loading: 'loading/loading/loading'
    }),
    methods: {
        handleSubmit() {
            this.$store.dispatch('app/contactForm/submitForm', this.contact)
                .then(() => {
                    Object.assign(this.contact, getDefaultContact());
                    if (!this.logged) {
                        this.contact.token = null;
                        this.$refs.captcha.reset();
                    }
                    this.$notify.success(this.$t('contactForm.response.success'));
                });
        },
        handleCaptchaVerify(token) {
            this.contact.token = token;
        },
        handleCaptchaExpired() {
            this.contact.token = null;
        }
    },
    beforeDestroy() {
        this.$store.dispatch('app/contactForm/reset');
    }
};
</script>



// WEBPACK FOOTER //
// src/components/app/ContactForm.vue